import type { CreditReportTabProps } from "../../types/tabs";
import { useCreditReportTab } from "../../hooks/useCreditReportTab";
import styles from "../../styles/applicationDetail.module.css";
import { CreditReportCoreLogicSection } from "./CreditReportCoreLogicSection";
import { CreditReportBureauActionsSection } from "./CreditReportBureauActionsSection";
import { CreditReportEquifaxBanner } from "./CreditReportEquifaxBanner";
import { CreditReportHistorySection } from "./CreditReportHistorySection";
import { CreditReportDeniedReasonSection } from "./CreditReportDeniedReasonSection";
import { CreditReportUnderwritingNotesSection } from "./CreditReportUnderwritingNotesSection";
import { CreditReportEmptySection } from "./CreditReportEmptySection";
import { CreditReportTabModals } from "./CreditReportTabModals";

export function CreditReportTab(props: CreditReportTabProps) {
  const tab = useCreditReportTab(props);

  return (
    <div
      className={styles.tabContent}
      data-testid="application-credit-report-tab-page"
    >
      <CreditReportCoreLogicSection tab={tab} />
      <CreditReportBureauActionsSection tab={tab} />
      <CreditReportEquifaxBanner tab={tab} />
      <CreditReportHistorySection tab={tab} />
      <CreditReportDeniedReasonSection tab={tab} />
      <CreditReportUnderwritingNotesSection tab={tab} />
      <CreditReportEmptySection tab={tab} />
      <CreditReportTabModals tab={tab} />
    </div>
  );
}
